import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function NotFoundPage() {
  return (
    <div className="bg-slate-50 min-h-[70vh] flex items-center justify-center py-16 px-4">
      <SEO
        title="Siden blev ikke fundet - Nordfyn Marine"
        description="Fejl 404: Siden du leder efter findes desværre ikke hos Nordfyn Marine."
      />
      <div className="max-w-md w-full bg-white p-8 sm:p-10 rounded-2xl border border-slate-200 shadow-sm text-center space-y-6">
        <div className="w-16 h-16 bg-[#0B1B2B]/10 text-[#0B1B2B] rounded-full flex items-center justify-center mx-auto text-2xl font-serif font-bold">
          404
        </div>

        <div className="space-y-2">
          <h1 className="font-serif font-bold text-2xl text-slate-900">
            Siden blev ikke fundet
          </h1>
          <p className="text-xs text-slate-600 leading-relaxed">
            Siden du leder efter eksisterer desværre ikke eller er blevet flyttet.
          </p>
        </div>

        <div className="flex flex-col gap-2.5 pt-2">
          <Link
            to="/"
            className="w-full bg-[#0B1B2B] hover:bg-[#122B42] text-white py-3 rounded-xl text-xs font-bold transition-colors"
          >
            Gå til forsiden
          </Link>

          <Link
            to="/baade"
            className="w-full bg-[#1E7BC1] hover:bg-[#2BABE3] text-white py-3 rounded-xl text-[11px] font-bold uppercase tracking-[0.2em] transition-colors"
          >
            Se alle både til salg
          </Link>

          <Link
            to="/kontakt"
            className="w-full bg-slate-100 hover:bg-slate-200 text-slate-800 py-3 rounded-xl text-xs font-semibold transition-colors"
          >
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  )
}
